import { Instance } from 'mobx-state-tree';
import { BillingPlanCancellationRequestedDtoModelBase } from './BillingPlanCancellationRequestedDtoModel.base';

/* The TypeScript type of an instance of BillingPlanCancellationRequestedDtoModel */
export interface BillingPlanCancellationRequestedDtoModelType extends Instance<typeof BillingPlanCancellationRequestedDtoModel.Type> {}

/* A graphql query fragment builders for BillingPlanCancellationRequestedDtoModel */
export { selectFromBillingPlanCancellationRequestedDto, billingPlanCancellationRequestedDtoModelPrimitives, BillingPlanCancellationRequestedDtoModelSelector } from './BillingPlanCancellationRequestedDtoModel.base';

/**
 * BillingPlanCancellationRequestedDtoModel
 */
export const BillingPlanCancellationRequestedDtoModel = BillingPlanCancellationRequestedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
